import React, { useState, useEffect, useRef } from "react";
import Check from "../../../utils/icons/Check";
import Close from "../../../utils/icons/Close";
import { closePopUp } from "../../../utils/Overlay";

export default function CollectYouTubeDestinationData({
  onCollect,
  onCancel,
  destination,
}: {
  onCollect: Function;
  onCancel: Function;
  destination: Destination;
}) {
  const [valid, setValidFlag] = useState(false);
  const [title, setTitle] = useState("");
  const titleInput = useRef(null);

  useEffect(() => {
    setValidFlag(title !== "");
  }, [title]);

  useEffect(() => {
    // @ts-ignore
    titleInput.current.focus();
  }, []);

  return (
    <div className="cf">
      <h3 className="tac">Type in your video details</h3>
      <small className="tac block mt1">Type a video title</small>
      <input
        type="text"
        className="block mt1"
        placeholder="Title"
        ref={titleInput}
        onChange={(e) => setTitle(e.target.value)}
      />

      <div className="right">
        <button
          type="button"
          className="reset as-link ib fz1 with-icon"
          onClick={() => {
            onCancel(destination);
            closePopUp();
          }}
        >
          <Close size={20} /> Cancel
        </button>
        <button
          type="button"
          className="reset secondary ml1 with-icon"
          onClick={() => {
            // onCollect(destination, title, playlist);
            onCollect(destination, title);
          }}
          disabled={!valid}
        >
          <Check size={16} /> Set
        </button>
      </div>
    </div>
  );
}
